import React, { useEffect, useRef } from 'react';
import dayjs from 'dayjs';
import './WaterfallChart.css';  // We'll use a separate CSS file for styling


import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";


/*
const randomColors = () => {
  return '#' + Math.floor(Math.random() * 16777215).toString(16);
}
  */
// The custom WaterfallChart component
const WaterfallChart = ({ height, data }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!chartRef.current) {
      am4core.useTheme(am4themes_animated);

      let chart = am4core.create("chartdiv", am4charts.XYChart);
      chartRef.current = chart; // Store the chart instance in the ref

      chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
      chart.paddingRight = 30;
      chart.dateFormatter.inputDateFormat = "hh:mm a";

      var colorSet = new am4core.ColorSet();
      colorSet.saturation = 0.4;

      /*var Group1 = chart.colors.getIndex(0);
      var Group2 = chart.colors.getIndex(2);
      var Group3 = chart.colors.getIndex(4);*/

      var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "name";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.inversed = true;
      categoryAxis.renderer.labels.template.disabled = true;

      var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.dateFormatter.dateFormat = "yyyy-MM-dd"; // Corrected date format
      dateAxis.renderer.minGridDistance = 70;
      dateAxis.strictMinMax = true;
      dateAxis.renderer.tooltipLocation = 0;
      dateAxis.dateFormats.setKey('day', 'yyyy-MM-dd'); // Corrected date format

      var series1 = chart.series.push(new am4charts.ColumnSeries());
      series1.columns.template.tooltipText = "{name}: {openDateX} - {dateX}";
      series1.dataFields.openDateX = "fromDate";
      series1.dataFields.dateX = "toDate";
      series1.dataFields.categoryY = "name";
      series1.columns.template.propertyFields.fill = "color"; // get color from data
      series1.columns.template.propertyFields.stroke = "color";
      series1.columns.template.strokeOpacity = 1;

      var labelBullet = series1.bullets.push(new am4charts.LabelBullet());
      labelBullet.label.text = "{name}";
      labelBullet.label.fill = am4core.color("#fff");
      labelBullet.locationX = 0.5;
    }

    // Update chart data
    if (chartRef.current) {
      let chart = chartRef.current;
      let newData = data && data.length > 0 ? data.map(task => ({
        ...task,
        fill: "#96C5AE"
      })) : [];
      const projectStartDate = dayjs(newData[0] ? newData[0].start_date : new Date());
      const projectEndDate = dayjs(newData[0] ? newData[newData.length - 1].end_date : new Date());

      chart.data = newData.map(task => ({
        name: task.title,
        fromDate: task.start_date,
        toDate: task.end_date,
        color: task.fill,
      }));

      chart.xAxes.getIndex(0).max = projectEndDate.toDate().getTime();
      chart.xAxes.getIndex(0).min = projectStartDate.toDate().getTime();
    }

    return () => {
      // Cleanup chart instance on component unmount
      if (chartRef.current) {
        chartRef.current.dispose();
        chartRef.current = null;
      }
    };
  }, [data]); // Only re-run the effect if data changes

  return (
    <div id="chartdiv" style={{ width: "100%", height: height }}></div>
  );
};

export default WaterfallChart;
